<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" >
      <b-col lg="10">
        <b-card >
          <div slot="header">Company Handled by User  
            <div class="card-header-actions">
              <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </div>
          </div>
          <b-row >
            <b-col md="5">
                  <b-input-group >
                      <b-input-group-prepend><span class="pt-2 mr-2">Filter By User</span></b-input-group-prepend>
                      <b-form-input readonly v-model="filter.username" placeholder="Select User !" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuUserShow=true">
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
            </b-col>
            <b-col md="5">
                  <b-row>
                    <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                  </b-row>
            </b-col>

          </b-row>

          <b-table
            class="mb-0"
            ref="table"
            outlined  responsive hover small
            style="font-size:smaller;" 
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            @row-clicked="rowClicked"
            show-empty
          >
          <template v-slot:cell(nomor)="data">
            {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
          </template>
          <template v-slot:cell(address)="data">
            {{ data.item.compaddr1 }}
            {{ data.item.compaddr2 }}
            {{ data.item.compaddr3 }}
          </template>
            <template v-slot:cell(action)="data">
              <div class="text-center">
              <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
                <i class="fa fa-trash"></i>
              </a>
              </div>
            </template>
            <template v-slot:cell(empty)="scope">
                  <h4>{{ scope.emptyText }}</h4>
            </template>
            <template v-slot:cell(emptyfiltered)="scope">
                <h4>{{ scope.emptyFilteredText }}</h4>
            </template>
          </b-table>
      <b-row >
        <b-col cols="5">
            <b-row>
              <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries
            </div>
              <b-button size="sm" class="ml-3" @click="lkuCompanyShow=true" :disabled="!(filter.username)" >Add Company</b-button>                          
            </b-row>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols="4" label="Limit per page"  style="margin-top:0 !important;">
              <b-form-select :options="[10, 15, 20, 25, 30, 40, 50]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="3">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

          <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
            <p class="mb-1">1 record is about to be permanently deleted</p>
            <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
          </b-modal>
        </b-card>

      </b-col>
    </b-row>

    <b-modal v-model="lkuUserShow" size="lg" :hide-footer="true" title="List of Users" :centered="true">
        <lku-user @click="onSelectUser"></lku-user>
    </b-modal>        
    <b-modal v-model="lkuCompanyShow" size="lg"  :hide-footer="true" title="List of Company" :centered="true">
        <lku-company @click="onSelectLkuCompany"></lku-company>
    </b-modal>        
  </div>
</template>


<script>
import toastr from "mini-toastr";
import lkuUser from "../lookup/lkuUser";
import lkuCompany from "../lookup/lkuCompany"
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuUser,lkuCompany},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        username: { required },
        kodeHeader: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      lkuUserShow:false,
      lkuCompanyShow:false,
      filter:{username:''},
      frmdata:{kodeHeader: '', username: '' },
      tblData: {
        tablename:'companyuser',
        page: 1,
        total: 0,
        limit:10,
        sortBy: 'company',
        sortDesc: false, customQuery:`user_id='-'`
      },
      tblFields: [
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "company",
            label: "Company Name",
            sortable: true
          },
          {
            key: "address",
            label: "Address",
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
      ],

      list:[],
    };
  },
  computed: {
    user_id() {
      return this.filter.user_id;
    },
  },
  watch: {  
    user_id: function (newval) {
      if (newval) {
          this.tblData.customQuery=`user_id=${newval}`;
      } else {
          this.tblData.customQuery='';
      }
    }
  },
  methods: {
    onSelectUser(_selected) {
        this.filter.username = _selected.username;
        this.filter.user_id = _selected.user_id;
        this.lkuUserShow=false;
        this.refresh();
    },
    onSelectLkuCompany: async function (_selected) {
      const ada = this.list.find( c => c.compcode==_selected.compcode);
      if (!(ada)) {
          await crud.insert(
            { tablename:'companyuser',                      
                data:{user_id:this.filter.user_id,
                    compcode:_selected.compcode
                    }
            });
        this.refresh();
      }
      this.lkuCompanyShow=false;
    },       
    data: async function() {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.customQuery=`user_id=${this.filter.user_id}`;

      const list = await crud.list(this.tblData);    
      // console.log(list) ;
      this.list=list; 
      return this.list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.filter.username= '';
        this.filter.user_id='';
        this.refresh();
    },

    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'companyuser', key:this.model.tablekey});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
